import {React, useCallback, useState, useRef} from 'react'
import emailjs from '@emailjs/browser';
import './pages.css'
import './contact.css'
import * as AiIcons from 'react-icons/ai'
import * as MdIcons from 'react-icons/md'
import * as BsIcons from 'react-icons/bs'
import * as FaIcons from 'react-icons/fa'
import Particles from "react-tsparticles";
import { loadFull } from "tsparticles";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
const Contact = () => {

    const particlesInit = useCallback(async (engine) => {
        console.log(engine);
        // you can initiate the tsParticles instance (engine) here, adding custom shapes or presets
        // this loads the tsparticles package bundle, it's the easiest method for getting everything ready
        // starting from v2 you can add only the features you need reducing the bundle size
        await loadFull(engine);
    }, []);

    const particlesLoaded = useCallback(async (container) => {
        await console.log(container);
    }, []);

    const form = useRef();

    const [submitted, setSubmitted] = useState(false);

    const handleSubmit = (e) => {
        //setSubmitted(true);
        e.preventDefault();

        emailjs.sendForm('service_lwpr4t4', 'template_h93jcsz', form.current, 'eJcj_V5pTEA5JwtFV')
          .then((result) => {
              console.log(result.text);
              form.current.reset();
              toast.success('Message sent!', {
                position: "bottom-center",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                });
          }, (error) => {
              console.log(error.text);
          });

      };
    

    return (
        <div style={{display: 'flex', flexDirection: 'column',justifyContent: 'center', alignItems: 'center', height: '90vh', backgroundColor: '#040c33', zIndex: 10 }}>
            <div class="fade-in-text1">
                <h1 className='head'>Contact Me</h1>

            </div>
            <div class="fade-in-text2">

                <div className='contactRow'>
                    <div className='contactInfo'>
                        <div className='icon'>
                            <MdIcons.MdLocationPin size ={30} />
                        </div>
                        <h3 className='contactText'> Edmonton, Alberta</h3>
                    </div>
                    <div className='contactInfo'>
                        <div className='icon'>
                            <AiIcons.AiOutlineMail size ={30} />
                        </div>
                        <h3 className='contactText'> altaafackbar@yahoo.ca</h3>
                    </div>
                    <div className='contactInfo'>
                        <div className='icon'>
                            <AiIcons.AiFillPhone size ={30} />
                        </div>
                        <h3 className='contactText'> {(780)} 802-1530</h3>
                    </div>
                </div>
                <form
                    onSubmit={handleSubmit}
                    ref = {form}
                >
                <div className="contact">
                    <input
                    type="name"
                    placeholder="Name"
                    name="name"
                    className="input"
                    required
                    />
                </div>
                <div className="contact">
                    <input
                    type="email"
                    placeholder="Email"
                    name="email"
                    className="input"
                    required
                    />
                </div>
                <div className="contact">
                    <textarea
                    placeholder="Your message"
                    name="message"
                    className="textinput"
                    required
                    />
                </div>
                <div className="mb-3 pt-0">
                    <button
                    className="submit"
                    type="sunmit"
                    >
                    Send message
                    </button>
                </div>
                </form>

            </div>


            <ToastContainer
            position="bottom-center"
            autoClose={5000}
            hideProgressBar={false}
            newestOnTop={false}
            closeOnClick
            rtl={false}
            pauseOnFocusLoss
            draggable
            pauseOnHover
            />
             
            
        <Particles
            id="tsparticles"
            init={particlesInit}
            loaded={particlesLoaded}
            options={{
                background: {
                    color: {
                        value: "#040c33",
                    },
                },
                fpsLimit: 120,
                interactivity: {
                    events: {
                        onClick: {
                            enable: true,
                            mode: "push",
                        },
                        onHover: {
                            enable: true,
                            mode: "repulse",
                        },
                        resize: true,
                    },
                    modes: {
                        push: {
                            quantity: 4,
                        },
                        repulse: {
                            distance: 100,
                            duration: 0.4,
                        },
                    },
                },
                particles: {
                    color: {
                        value: "#ffffff",
                    },
                    links: {
                        color: "#714d97",
                        distance: 150,
                        enable: true,
                        opacity: 0.5,
                        width: 1,
                    },
                    collisions: {
                        enable: false,
                    },
                    move: {
                        directions: "none",
                        enable: true,
                        outModes: {
                            default: "bounce",
                        },
                        random: false,
                        speed: 2,
                        straight: false,
                    },
                    number: {
                        density: {
                            enable: true,
                            area: 800,
                        },
                        value: 80,
                    },
                    opacity: {
                        value: 0.5,
                    },
                    shape: {
                        type: "circle",
                    },
                    size: {
                        value: { min: 1, max: 5 },
                    },
                },
                detectRetina: true,
            }}
        />
        </div>
    )
}

export default Contact